/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {IInitData, IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {
    ITombOfNefertitiGameData,
    ITombOfNefertitiInitData,
    ITombOfNefertitiServerData
} from "./data/ITombOfNefertitiServerData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {TombOfNefertitiGameConfig} from "../TombOfNefertitiGameConfig";

export class TombOfNefertitiServerDataParser extends SpinServerDataParser {

    private _isRestore: boolean = false;

    constructor() {
        super();
    }

    public parseReels(rawData: IServerData): string[][] {
        return this.parseReelArrays(rawData.reels);
    }

    public parseRespinPositionsAfter(rawData: ITombOfNefertitiServerData): boolean[] {
        return this.parseRespinPositions(rawData);
    }

    public parseIsRestoreState(rawData: IInitData): boolean {
        this._isRestore = rawData.isRestoreState;

        return rawData.isRestoreState;
    }

    public parsePayoutMultiplier(rawData: ITombOfNefertitiInitData): number {
        return rawData.payoutWinMultiplier;
    }

    public parseNextMultiplier(rawData: ITombOfNefertitiGameData): number {
        return rawData.payoutMultiplierNext !== null ? rawData.payoutMultiplierNext : 1;
    }

    parseCurrentMultiplier(rawData: ITombOfNefertitiServerData): number {
        return rawData.payoutWinMultiplier != null ? rawData.payoutWinMultiplier : 1;
    }

    parseCurseFeatureTriggered(rawData: ITombOfNefertitiGameData): boolean {
        TombOfNefertitiGameConfig.instance.CURRENT_SPIN_HAS_CURSE = rawData.curseOfNefertitiTrigger || rawData.curseRespin;
        return rawData.curseOfNefertitiTrigger;
    }

    parseCurseFeatureReSpinTriggered(rawData: ITombOfNefertitiGameData): boolean {
        return rawData.curseRespin;
    }

    parseWildRaidFeatureTriggered(rawData: ITombOfNefertitiGameData): boolean {
        return rawData.wildRaidTrigger;
    }

    parseWildRaidPositions(rawData: ITombOfNefertitiGameData): number[] {
        return rawData.wildRaidPositions;
    }

    parseRespinPlayed(rawData: ITombOfNefertitiServerData) {
        return rawData.respinPlayed;
    }

    parseRespinTriggeredThisSpin(rawData: ITombOfNefertitiGameData) {
        return rawData.respinBaseTriggeredThisSpin || rawData.respinFSTriggeredThisSpin;
    }

    parseCurrentGameMode(rawData: ITombOfNefertitiServerData) {
        return rawData.mode;
    }

    parseNextGameMode(rawData: ITombOfNefertitiServerData) {
        return rawData.nextMode;
    }

    parseNumberOfFreespinsPlayed(rawData: ITombOfNefertitiServerData): number | undefined {
        return rawData.freespinPlayed;
    }

    parseTotalRespinWin(rawData: ITombOfNefertitiServerData): number {
        return rawData.totalRespinWin;
    }

    /**
     * @description: To create 15 reels individually from the response that we get of 3*5 matrix of reels.
     *
     * @param {array} rawReels 2d array of 3*5 reels.
     *
     * @returns: {array} 15 individual reels.
     */
    private parseReelArrays(rawReels: string[][]): string[][] {
        let result: string[][] = [];

        for (let i: number = 0; i < rawReels.length; i++) {
            for (let j: number = 0; j < rawReels[i].length; j++) {
                result.push([rawReels[i][j]]);
            }
        }
        return result;
    }

    private parseRespinPositions(rawData: ITombOfNefertitiServerData): boolean[] {
        return rawData.respinPositionsAfter || rawData.respinPositions;
    }

    parseIndexesForAttention(rawData: ITombOfNefertitiGameData): number[] {
        let attentionStartIndex: number = -1;

        let restoreIndex: number = 1;

        if(this._isRestore){
            restoreIndex = 0;
            this._isRestore = false;
        }

        if (rawData.nearWinReels) {
            for (let i = 0; i < rawData.nearWinReels.length; i++) {
                let reelNearWin: any = rawData.nearWinReels[i] as any;
                let attentionStartIndexUpdated: boolean = false;
                for (let j = 0; j < reelNearWin.length; j++) {
                    if (reelNearWin[j]) {
                        attentionStartIndex = i * 3 + j;
                        if (restoreIndex) {
                            attentionStartIndexUpdated = true;
                            break;
                        } else {
                            restoreIndex++;
                        }
                    }
                }
                if (attentionStartIndexUpdated) {
                    break;
                }
            }
        }

        return this.getReelsForAttention(attentionStartIndex, rawData);
    }


    private getReelsForAttention(startIndex: number, rawData: ITombOfNefertitiGameData): number[] {
        let attentionReels: number[] = [],
            activeReels: boolean[] = (rawData.respinPositionsBefore || rawData.respinPositions).reduce((acc, currEl) => acc.concat(<any>currEl), []),
            nearWinReels: boolean[] = rawData.nearWinReels ? (rawData.nearWinReels).reduce((acc, currEl) => acc.concat(<any>currEl), []) : [];

        for (let i: number = startIndex; i < activeReels.length; i++) {
            if (nearWinReels[i]) {
                attentionReels.push(i);
            }
        }

        return attentionReels;
    }

    parseIndexBeforeAttention(rawData: ITombOfNefertitiGameData): number {
        let attentionStartIndex: number = -1;

        for (let i = 0; i < rawData.nearWinReels.length; i++) {
            let reelNearWin: any = rawData.nearWinReels[i] as any;
            let attentionStartIndexUpdated: boolean = false;
            for (let j = 0; j < reelNearWin.length; j++) {
                if (reelNearWin[j]) {
                    attentionStartIndexUpdated = true;
                    attentionStartIndex = i * 3 + j;
                    break;
                }
            }
            if (attentionStartIndexUpdated) {
                break;
            }
        }

        return this.getLastReelBeforeAttention(attentionStartIndex, rawData);
    }

    private getLastReelBeforeAttention(attentionStartIndex: number, rawData: ITombOfNefertitiServerData): number {
        if(rawData.mode === GameMode.NORMAL){
            let returnableValue = attentionStartIndex - 1;
            if(returnableValue < 0){
                returnableValue = NaN;
            }
            return returnableValue;
        }

        let lastActiveReelBeforeAttention: number = attentionStartIndex,
            activeReels: boolean[] = (rawData.respinPositionsBefore || rawData.respinPositions).reduce((acc, currEl) => acc.concat(<any>currEl), []);

        for (let i: number = 0; i < attentionStartIndex; i++) {
            if (activeReels[i]) {
                lastActiveReelBeforeAttention = i;
            }
        }

        return lastActiveReelBeforeAttention;
    }
}